import { CommonGlobalSystem } from './SystemBase';

export class ResetEventsSystem extends CommonGlobalSystem {
  run(): void {
    this.services.eventBus.resetEvents();
  }
}
